import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/layouts/default.vue").then(m => m.default || m)),
  dentsu: defineAsyncComponent(() => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/layouts/dentsu.vue").then(m => m.default || m))
}